import { fetcher } from '@commenda/utils';

import type { ChatRoomSubscriptionStatus } from '@prisma/client';

export async function setMyChatRoomSubscription(
  chatRoomId: string,
  status: ChatRoomSubscriptionStatus
) {
  const res = await fetcher(`chatRoom/${chatRoomId}/subscription`, {
    method: 'PUT',
    body: { status },
  });

  if (!res.ok) throw new Error('Failed to update subscription');

  return res.json();
}
